import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';

export default class DestinationErrorRoute extends Route {
  queryParams = {
    reason: {
      refreshModel: false,
    },
  };

  @service declare transition: Services['transition'];

  beforeModel(transition: Transition): void {
    // Check for enabled tabs again after a hard refresh
    if (!transition.from) {
      this.transition.redirectToEnabledTab(transition);
    }
  }
}
